import React from 'react';
import './Card.css';

const Card = ({ children, className = '', padding = 'md', hoverable = false, ...rest }) => {
  return (
    <div
      className={`card card--pad-${padding} ${hoverable ? 'card--hoverable' : ''} ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
};

Card.Header = ({ children, className = '' }) => (
  <div className={`card__header ${className}`}>{children}</div>
);

Card.Title = ({ children, className = '' }) => (
  <h3 className={`card__title ${className}`}>{children}</h3>
);

Card.Subtitle = ({ children, className = '' }) => (
  <p className={`card__subtitle ${className}`}>{children}</p>
);

Card.Body = ({ children, className = '' }) => (
  <div className={`card__body ${className}`}>{children}</div>
);

Card.Footer = ({ children, className = '' }) => (
  <div className={`card__footer ${className}`}>{children}</div>
);

export default Card;
